import React, { Dispatch, FC, SetStateAction, useMemo } from 'react'
import { DeleteIcon } from 'uiKit/icons/Icons'
import { ServiceUserType } from 'models/ServiceUsersTypes'
import {
  MultipleDeleteButton,
  MultipleEditBarContainer,
  MultipleEditBarLabel,
  MultipleEditSection,
} from './MultipleEditBar.styles'

interface Props {
  showMultipleBar: boolean
  selectedServiceUsersId: number[]
  setDeleteUserModal: Dispatch<SetStateAction<{ isOpen: boolean, selectedUser: ServiceUserType | null }>>
}

/** Bulk selection chrome — count label + delete. */
const MultipleEditBar: FC<Props> = ({
  showMultipleBar,
  selectedServiceUsersId,
  setDeleteUserModal,
}) => {
  const multipleDeleteHandler = () => {
    setDeleteUserModal(prevState => ({
      ...prevState,
      isOpen: true
    }))
  }

  const editBarLabel = useMemo(() => {
    const isSingleUser = selectedServiceUsersId.length === 1
    return `${selectedServiceUsersId.length} ${isSingleUser ? 'user' : 'users'} selected`
  }, [selectedServiceUsersId])

  return (
    <MultipleEditBarContainer showMultipleBar={showMultipleBar}>
      <MultipleEditSection>
        <MultipleEditBarLabel>
          { editBarLabel }
        </MultipleEditBarLabel>
      </MultipleEditSection>
      <MultipleEditSection />
      <MultipleEditSection />
      <MultipleEditSection />
      <MultipleEditSection />
      <MultipleEditSection />
      <MultipleEditSection>
        <MultipleDeleteButton onClick={multipleDeleteHandler}>
          <DeleteIcon />
        </MultipleDeleteButton>
      </MultipleEditSection>
    </MultipleEditBarContainer>
  )
}

export default MultipleEditBar
